import { useTranslation } from "react-i18next";
import { Building2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useVisibleClinics } from "@/hooks/useVisibleClinics";

interface ClinicTagProps {
  clinicId: string | null | undefined;
  /** Força exibição mesmo com uma única clínica visível (default: false). */
  alwaysShow?: boolean;
  className?: string;
}

/**
 * Badge discreto com o nome da clínica de origem de um registro de histórico.
 * Por padrão só aparece quando o usuário tem mais de uma clínica visível,
 * evitando ruído no caso de clínica única.
 */
export function ClinicTag({ clinicId, alwaysShow = false, className }: ClinicTagProps) {
  const { t } = useTranslation("common");
  const { clinicsById, hasMultipleVisible } = useVisibleClinics();

  if (!clinicId) return null;
  if (!hasMultipleVisible && !alwaysShow) return null;

  const clinic = clinicsById[clinicId];
  if (!clinic) return null;

  return (
    <Badge
      variant="outline"
      className={className}
      aria-label={t("clinicTag.ariaLabel", { name: clinic.name })}
    >
      <Building2 className="mr-1 h-3 w-3" aria-hidden="true" />
      <span className="truncate">{clinic.name}</span>
    </Badge>
  );
}
